export * from './speaker-page.view';